var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.badge
        ? _c(
            "v-badge",
            { attrs: { color: "error" } },
            [
              _c("span", { attrs: { slot: "badge" }, slot: "badge" }, [
                _vm._v(_vm._s(_vm.badge))
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticStyle: {
                    display: "block",
                    margin: "auto",
                    "border-width": "2px"
                  },
                  attrs: {
                    outlined: "",
                    small: "",
                    fab: "",
                    color: _vm.active ? "primary" : "lightgrey"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("click")
                    }
                  }
                },
                [
                  _vm.icon
                    ? _c("v-icon", [_vm._v(_vm._s(_vm.icon))])
                    : _c("div", { staticClass: "subtitle font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.iconText))
                      ])
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-btn",
            {
              staticStyle: {
                display: "block",
                margin: "auto",
                "border-width": "2px"
              },
              attrs: {
                outlined: "",
                small: "",
                fab: "",
                color: _vm.active ? "primary" : "lightgrey"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("click")
                }
              }
            },
            [
              _vm.icon
                ? _c("v-icon", [_vm._v(_vm._s(_vm.icon))])
                : _c("div", { staticClass: "subtitle font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.iconText))
                  ])
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "caption text-center mt-2",
          class: _vm.active ? "primary--text" : null
        },
        [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }